import React, { useEffect, useRef } from "react";
import { useGlobalContext } from "context/global";
import { CURRENT_COUNTRY } from "utils/constants";

const GorgiasHelpCenter = ({ data }) => {
	const uid = data?.uid;
	const containerRef = useRef(null);
	const { language } = useGlobalContext();

	let hcUrl = "/en-US";
	if (language === "default") {
		hcUrl = CURRENT_COUNTRY === "nl" ? "/nl-NL" : "/de-DE";
	}

	useEffect(() => {
		if (!uid) return;

		const url = new URL(window.location.href);
		url.searchParams.set("hcUrl", hcUrl);
		window.history.replaceState({}, "", url);

		const script = document.createElement("script");
		script.defer = true;
		script.src = `https://help-center.gorgias.help/api/help-centers/loader.js?v=2`;
		script.setAttribute("data-gorgias-loader-help-center", "");
		script.setAttribute("data-gorgias-help-center-uid", uid);

		document.body.appendChild(script);

		const observer = new MutationObserver(() => {
			const gorgiasSection = document.querySelector(
				`section[data-gorgias-help-center-uid='${uid}']`
			);

			if (gorgiasSection && containerRef.current) {
				containerRef.current.appendChild(gorgiasSection);
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		return () => {
			observer.disconnect();
			document.body.removeChild(script);
		};
	}, [uid, language]);

	if (!uid) return null;

	return <div ref={containerRef} />;
};

export default GorgiasHelpCenter;
